// removed by extract-text-webpack-plugin
module.exports = {"White":"#FFFFFF","menuDateRange":"G149a50 Gd86bb3 Gd71c60 G583c98 Ge45707 Gf181d5","mobile":"Gddb24d G18c4ca"};